/**
 * translate validations rules into vuelidate valid keys and values
 * @todo negotiate a convention with backend to make
 * this less orthopedic
 *
 * @param {string[]} rules
 */
export function getValidators(rules) {
    return rules
        .map(rule => {
            if (rule === "required") {
                return { name: "required" }
            }

            if (/^required_if:/.test(rule)) {
                return {
                    name: "requiredIf",
                    args: fields => {
                        const [prop, val] = rule.split(":", 2)[1].split(",", 2)
                        return fields[prop] == val
                    },
                }
            }

            if (rule === "email") {
                return { name: "email" }
            }

            if (rule === "url") {
                return { name: "url" }
            }

            if (/^max:/.test(rule)) {
                return {
                    name: "maxLength",
                    args: +rule.split(":", 2)[1],
                }
            }

            if (/^min:/.test(rule)) {
                return {
                    name: "minLength",
                    args: +rule.split(":", 2)[1],
                }
            }

            console.warn(`Unknown rule: ${rule}.`)
        })
        .filter(Boolean)
}
